import { useState } from "react";
import { Reveal } from "@/components/motion/Reveal";

const FORMBACKEND_SHAPE_HOUSE = "https://www.formbackend.com/f/1919b4504c6d8fa1";

export default function ShapeHouse() {
  const [answer, setAnswer] = useState("");
  const [email, setEmail] = useState("");

  const redirect =
    typeof window !== "undefined"
      ? `${window.location.origin}/thank-you`
      : "/thank-you";

  return (
    <div data-testid="shape-house-page">
      <section data-testid="shape-hero" className="bg-ivory">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-32 md:pt-48 pb-16">
          <p className="eyebrow eyebrow-brass mb-6">Shape the House</p>
          <h1 className="font-display leading-[1.02]" style={{ fontSize: "clamp(60px, 10vw, 160px)", fontWeight: 300 }}>
            Help decide what we <em className="italic">make next.</em>
          </h1>
          <p className="mt-10 max-w-2xl text-[16px] leading-[1.8] text-pencil">
            Tell us which gap we should close next. The founding list gets more than early access. What you tell us shapes what we make, and what we make first.
          </p>
        </div>
      </section>

      <section data-testid="shape-form" className="bg-cream">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 py-24 md:py-32">
          <Reveal>
            <form
              action={FORMBACKEND_SHAPE_HOUSE}
              method="POST"
              acceptCharset="UTF-8"
              className="grid md:grid-cols-12 gap-10"
              data-testid="shape-form-el"
            >
              <input type="hidden" name="_redirect" value={redirect} />

              <div className="md:col-span-5">
                <p className="font-mono-stamp text-pencil">The Prompt</p>
                <h3 className="font-display text-4xl md:text-5xl mt-6 leading-[1.18]" style={{ fontWeight: 300 }}>
                  What's the overlooked, uncomfortable moment in your day you wish someone had quietly <em className="italic">handled?</em>
                </h3>
                <p className="mt-6 text-pencil text-sm">We read every one.</p>
              </div>
              <div className="md:col-span-7 space-y-8">
                <div>
                  <label className="font-mono-stamp text-pencil block mb-3" htmlFor="shape-answer">Your answer</label>
                  <textarea
                    id="shape-answer"
                    name="answer"
                    data-testid="shape-answer-input"
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                    rows={7}
                    className="input-box resize-none"
                    placeholder="Tell us the small gap..."
                    required
                  />
                </div>
                <div>
                  <label className="font-mono-stamp text-pencil block mb-3" htmlFor="shape-email">Email</label>
                  <input
                    id="shape-email"
                    name="email"
                    data-testid="shape-email-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="input-box"
                    placeholder="your@email"
                    required
                  />
                </div>
                <button
                  type="submit"
                  data-testid="shape-submit"
                  className="btn-ink"
                >
                  Send it to the house
                </button>
              </div>
            </form>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
